import API, { defaultHeaders } from '@/api';

const fetchCreateBulk = payload => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
  return fetch(`${API}/panel/invitation/bulk/`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
};

export default fetchCreateBulk;
